export default {
  // 查询是否包含保险
  async queryIncludeInsurance(params) {
    return await this.fetch(
      "orderquery/callCenter/queryIncludeInsurance",
      params
    );
  }
};



// WEBPACK FOOTER //
// ./src/interfaces/modules/pay.js